import React, { useEffect, useState } from 'react'
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import DOMPurify from 'dompurify';
// images
import hero from "./Images/hero.svg";
import aboutimage from "./Images/aboutimage.svg";


// icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";


import LeaderShipTeamsRBM from './LeaderShipTeamsRBM';
import axios from 'axios';

interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}


interface datastructure{
  title:string,
  content:string,
  id:number,
  image:string,
  name:String,
}

export const RMBLeaders = () => {

  const[bannerdata, setBannerdata] = useState<banner[]>([]);

  const[pagedata, setPagedata] = useState<datastructure[]>([]);


  const [isExpanded, setIsExpanded] = useState(false);

  // Define the maximum length before truncating the content
  const maxLength = 950; // Set a character limit to truncate
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/aboutbanner",{
            
      });

        console.log('banner data',response.data)
        setBannerdata(response.data);
        console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("banner Not Found:", error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/rmbLeader",{
            
      });

        console.log('rmbLeader data',response.data)
        setPagedata(response.data);
        console.log("rmbLeader data in a array",pagedata);
      } catch (error) {
        console.error("rmbLeader Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
  <Header/>
  {bannerdata.filter((items)=>items.pageName ==='RMBLeaders').map((item)=>(
    <div
        className="w-full h-[451px] relative"
        style={{
          backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${item.image.replace(/\\/g, '/')})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
        <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
          <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
          {item.title}          </h2>
          <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
            {item.content}
          </p>
          <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
            <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/"
            >
              {" "}
              <FaHome />
              Home
            </a>
            <a
              className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/about"
            >
              {" "}
              <IoIosArrowForward />
              About us
            </a>
            <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/about"
            >
              {" "}
              <IoIosArrowForward />
              About RMB
            </a>
          </div>
        </div>
      </div>
  ))}
  
     {pagedata.map((items)=>(
      <div className="bg-[#1E2A3A] py-14 px-[8%] ">
        <span className="text-[#FDBC12] text-[16px]">KNOW MORE</span>
        <h2 className="text-[#F1F4F9] text-[39px] font-bold">{items.title}</h2>
        <div className="flex flex-wrap gap-y-[40px] w-[100%]">
          <div className="lg:w-[55%] w-[100%] pr-[40px]">
            <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px]" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(items.content) }}>
           
            </p>
          </div>
          <div className="lg:w-[45%] w-[100%] flex lg:justify-end justify-center">
            <img className="w-[80%]" src={`https://rmbbackend.rmbjaipur.com/${items.image}`} alt="" />
          </div>
        </div>
      </div>
     ))}
      {/* <div className="bg-[#1E2A3A] py-14 px-[8%] ">
        <span className="text-[#FDBC12] text-[16px]">KNOW MORE</span>
        <h2 className="text-[#F1F4F9] text-[39px] font-bold">About RMB Leader</h2>
        <div className="flex flex-wrap gap-y-[40px] w-[100%]">
          <div className="lg:w-[55%] w-[100%] pr-[40px]">
            <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px]">
            The heart of the Rotary Means Business Fellowship is the local RMB chapter. Rotary Means Business began as one local chapter, then a few local chapters, and finally expanded into a worldwide phenomenon and a Rotary International Fellowship.
              <br /> <br />
              Rotary Clubs and Districts have found that an active local RMB chapter can serve as one more value-added benefit to Rotary membership, and therefore assist with both recruitment and retention of Rotarians. <br />
               We are pleased that you are interested in forming a local chapter of the Rotary Means Business Fellowship. This document is intended to give Rotarians guidance in setting up and operating a local chapter.
            </p>
          </div>
          <div className="lg:w-[45%] w-[100%] flex lg:justify-end justify-center">
            <img className="w-[80%]" src={aboutimage} alt="" />
          </div>
        </div>
      </div> */}
 {/* teams */}

     <LeaderShipTeamsRBM/>


 <Footer/>
    </div>
  )
};
export default RMBLeaders;

